import { Gift } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectVoucherDataFromCart } from 'store/cartSlice/selectors';

const CartSummaryVoucher = () => {
  const { t } = useTranslation();
  const {
    voucherCode: { code },
  } = useSelector(selectVoucherDataFromCart);

  if (!code) return null;

  return (
    <div className="flex flex-wrap gap-[8px] justify-between items-center py-[8px] px-[16px] bg-green-100 mt-[16px] rounded-md">
      <div className="flex items-center gap-[8px]">
        <Gift />
        <p className="p2-medium font-normal ">{t('ticketSale.appliedCode')}</p>
      </div>
      <p className="p2-medium">{code}</p>
    </div>
  );
};

export default CartSummaryVoucher;
